import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'
import PlanningStackedBar from 'modules/project_management/components/PlanningStackedBar'
import { budgetTypesEnum } from 'modules/project_management/lib/constants'

interface FixedCostPlanningCounterProps {
  fixedCostPlanning: number
  totalCostCents: number
  currency: string
  locale: string
}

const FixedCostPlanningCounter = ({
  fixedCostPlanning,
  totalCostCents,
  currency,
  locale,
}: FixedCostPlanningCounterProps) => {
  return (
    <InsightCard
      title={i18n.t('project_management.details.total_cost')}
      titleGap="s0"
      showOverageTag={fixedCostPlanning < totalCostCents}
    >
      <PlanningStackedBar
        planningSelected={budgetTypesEnum.fixedCostPlanning || budgetTypesEnum.projectFixedCost}
        allocated={totalCostCents / 100}
        planned={fixedCostPlanning / 100}
        currency={currency}
        locale={locale}
      />
    </InsightCard>
  )
}

export default FixedCostPlanningCounter
